module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/Discovery-Of-Witches-A-S1.648c407.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/Discovery-Of-Witches-A-S1.jpg
// module id = P7/a
// module chunks = 0